import { render, staticRenderFns } from "./ChbSelect.vue?vue&type=template&id=3e057f70&scoped=true"
import script from "./ChbSelect.vue?vue&type=script&lang=js"
export * from "./ChbSelect.vue?vue&type=script&lang=js"
import style0 from "./ChbSelect.vue?vue&type=style&index=0&id=3e057f70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e057f70",
  null
  
)

export default component.exports